import doubleRightIcon from '@iconify/icons-ant-design/right-circle-filled';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import SplitPane from 'react-split-pane';
import { zIndex } from '@/theme/zIndex';
import { IconGeneric } from '@/widgets/components/icon';
import styled from 'styled-components';

const SplitPaneWrapper = styled.div`
  .Resizer {
    position: relative;
  }

  .SplitPane {
    background-color: #fafbfe;
  }

  .Pane.vertical.Pane2 {
    transition: width 0.5s linear;
    box-shadow: 0 2px 20px 0 rgba(184, 195, 212, 0.3);
  }
`;

const StyledResizerHandle = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50vh;
  margin-left: -18px;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  backdrop-filter: blur(10px);
  box-shadow:
    -1px 3px 4.5px 0 rgba(89, 126, 247, 0.03),
    -1px 0.5px 7px 0 rgba(89, 126, 247, 0.03);
  border: solid 1px rgba(17, 26, 55, 0.1);
  background-color: #fafbfe;
  z-index: ${zIndex.controls};
  cursor: pointer;
`;

const RotatableIcon = styled(IconGeneric)`
  transform: ${(props) => `rotate(${props.customrotate}deg) !important`};
`;

const ScalableOnHoverWrapper = styled.div`
  display: flex;

  @keyframes scale {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(0.9);
    }
    50% {
      transform: scale(0.85);
    }
    75% {
      transform: scale(0.9);
    }
    100% {
      transform: scale(1);
    }
  }

  :hover {
    animation: scale 0.4s;
  }
`;

const expansionSizes = {
  SINGLE_CARD_COLUMN_WIDTH: 365,
  DOUBLE_CARD_COLUMN_WIDTH: 690,
  TRIPLE_CARD_COLUMN_WIDTH: 1015,
};

const rotateResizerIconBySize = {
  [expansionSizes.SINGLE_CARD_COLUMN_WIDTH]: -180,
  [expansionSizes.DOUBLE_CARD_COLUMN_WIDTH]: 0,
  [expansionSizes.TRIPLE_CARD_COLUMN_WIDTH]: 0,
};

function ResizerHandle(props) {
  const { cardPanelSize } = props;
  return (
    <StyledResizerHandle onClick={props.onClick} data-cy="pane-resize-arrow">
      <ScalableOnHoverWrapper>
        <RotatableIcon
          color="rgba(16, 25, 56, .7)"
          size="30px"
          customrotate={rotateResizerIconBySize[cardPanelSize]}
          icon={doubleRightIcon}
        />
      </ScalableOnHoverWrapper>
    </StyledResizerHandle>
  );
}

export default function MapCardSplitPane(props) {
  const [resizerNode, setResizerNode] = useState(null);
  const [cardPanelSize, setCardPanelSize] = useState(
    expansionSizes.DOUBLE_CARD_COLUMN_WIDTH
  );

  const mapPaneRef = useRef(null);

  useEffect(() => {
    const resizerDomNode = document.querySelector('.Resizer.vertical');
    setResizerNode(resizerDomNode);
  }, []);

  const handleSizeChangeRequested = () => {
    switch (cardPanelSize) {
      case expansionSizes.DOUBLE_CARD_COLUMN_WIDTH:
        setCardPanelSize(expansionSizes.SINGLE_CARD_COLUMN_WIDTH);
        break;
      case expansionSizes.SINGLE_CARD_COLUMN_WIDTH:
        setCardPanelSize(expansionSizes.TRIPLE_CARD_COLUMN_WIDTH);
        break;
      default:
        setCardPanelSize(expansionSizes.DOUBLE_CARD_COLUMN_WIDTH);
    }
  };

  return (
    <SplitPaneWrapper>
      <SplitPane
        ref={mapPaneRef}
        split="vertical"
        size={cardPanelSize}
        allowResize={false}
        defaultSize={expansionSizes.DOUBLE_CARD_COLUMN_WIDTH}
        primary="second"
      >
        {props.children}
      </SplitPane>
      {resizerNode &&
        ReactDOM.createPortal(
          <ResizerHandle
            onClick={handleSizeChangeRequested}
            cardPanelSize={cardPanelSize}
          />,
          resizerNode
        )}
    </SplitPaneWrapper>
  );
}
